import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Container } from 'reactstrap';
import { compose, lifecycle, withHandlers } from 'recompose';
import { eventValueHandler, mapDispatchToProps } from '../../../common';
import { FormControlItem } from '../../composed';
import { withState } from '../../higher-order';
import { Loading } from '../../partials';
import './login.css';

const Login = ({
  error,
  showError,
  hideError,
  username,
  password,
  setUsername,
  setPassword,
  submitted,
  submitting,
  onSubmit
}) => (
    <section className='login flex-center'>
      <Container>
        <h1 className='mb-3'>
          Login
        </h1>
        <form
          className={classNames({ 'was-validated': submitted })}
          noValidate
          onSubmit={onSubmit}>
          <Alert
            color='danger'
            className='mb-5'
            isOpen={showError}
            toggle={hideError}>
            {error}
          </Alert>
          <FormControlItem
            id='username'
            label='Email'
            onChange={eventValueHandler(setUsername)}
            required
            type='email'
            value={username}>
            <div className='invalid-feedback ml-5'>
              A valid email is required.
            </div>
          </FormControlItem>
          <FormControlItem
            id='password'
            onChange={eventValueHandler(setPassword)}
            required
            type='password'
            value={password}>
            <div className='invalid-feedback ml-5'>
              Password is required.
            </div>
          </FormControlItem>
          <Button
            color='primary'
            type='submit'
            disabled={submitting}>
            {
              submitting ?
                <Loading /> :
                'Submit'
            }
          </Button>
        </form>
      </Container>
    </section>
  );

export default compose(
  connect(
    ({ session: { isFetching, error } }) => ({
      isFetching,
      error
    }),
    mapDispatchToProps(({ session: { login } }) => ({
      login
    }))
  ),
  withState({
    username: '',
    password: '',
    submitted: false,
    submitting: false,
    showError: false
  }),
  lifecycle({
    componentWillReceiveProps({ isFetching, error: newError, showError }) {
      const {
        isFetching: wasFetching,
        setSubmitting,
        setShowError
      } = this.props;

      if (wasFetching && !isFetching) {
        setSubmitting(false);

        if (!showError && newError) {
          setShowError(true);
        } else if (showError && !newError) {
          setShowError(false);
        }
      }
    }
  }),
  withHandlers({
    onSubmit: ({
      login,
      username,
      password,
      setSubmitted,
      setSubmitting
    }) =>
      (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSubmitted(true);

        if (e.target.checkValidity()) {
          setSubmitting(true);
          login(username, password);
        }
      },
    hideError: ({ setShowError }) => () => setShowError(false)
  })
)(Login);



// WEBPACK FOOTER //
// ./src/components/pages/login/login.js